var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 115,
    viewBox: "0 0 116 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.8904 72.4889C73.4798 72.4889 71.5244 74.4429 71.5244 76.8549C71.5244 79.2656 73.4791 81.2209 75.8904 81.2209C78.3011 81.2209 80.2565 79.2662 80.2565 76.8549C80.2558 74.4424 78.3011 72.4889 75.8904 72.4889ZM42.0381 72.4889C39.6275 72.4889 37.6721 74.4429 37.6721 76.8549C37.6721 79.2656 39.6268 81.2209 42.0381 81.2209C44.4488 81.2209 46.4042 79.2662 46.4042 76.8549C46.4042 74.4424 44.4494 72.4889 42.0381 72.4889ZM89.2469 57.4002L101.438 21.6703L36.9711 21.6697L33.4437 10.8701L14.7959 10.8708L16.6339 17.3043H28.7759L41.2442 55.478L36.7315 70.0767H84.8183L86.6564 63.6432H45.2855L47.4749 57.4007L89.2469 57.4002Z",
    fill: "#0876A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3242 33.7793H79.9408",
    stroke: "#9FC960",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7861 43.9336H73.9407",
    stroke: "#9FC960",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartTracking);
export default __webpack_public_path__ + "static/media/cart-tracking.d72c73f9baaa39d40ce75e20dff92ca9.svg";
export { ForwardRef as ReactComponent };